enum TemplateTypes {
  Slogan = "slogan",
  Collage = "collage",
}

export { TemplateTypes };
